/**
 * StatusPill — a status word in a table cell, rendered as a tinted pill.
 *
 * This is the shared `Badge`, not a pill of its own. It used to carry a
 * three-row tone table and its own shape props, which made it a second answer
 * to a question the theme already answers: a restyle of `badge.*` would have
 * moved every lozenge in the product except Bird's status words.
 *
 * `StatusTone` is `success` / `warning` / `neutral`, which are three of the
 * six Badge tones by the same names, so the mapping is the identity.
 *
 * The AA reasoning that justified the old on-tint tokens is preserved by the
 * move rather than lost. It used `text.onSuccessBg` because `text.success` on
 * `bg.success` is only 4.16:1, and the pill is 10px text; every
 * `badge.<tone>.fg` / `badge.<tone>.bg` pair is pinned at >=4.5:1 in BOTH
 * modes by the badge tone matrix in theme/__tests__/contrast.test.ts.
 *
 * Status is carried by the WORD as well as the colour — never colour alone.
 */

import { Badge } from '@chakra-ui/react';

import type { StatusTone } from './markdownTable.utils';

export function StatusPill({ value, tone }: { readonly value: string; readonly tone: StatusTone }) {
  return (
    <Badge variant={tone} size="sm">
      {value}
    </Badge>
  );
}
